import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import WorkItemAttribute from '~/vue_shared/components/work_item_attribute.vue';
import { getIterationPeriod } from 'ee/iterations/utils';
export default {
    name: 'WorkItemIterationAttribute',
    components: {
        WorkItemAttribute
    },
    props: {
        iteration: {
            type: Object,
            required: true
        },
        namespacePath: {
            type: String,
            required: true
        }
    },
    computed: {
        iterationId () {
            const { id } = this.iteration;
            return id ? getIdFromGraphQLId(id) : '';
        },
        iterationPeriod () {
            return this.iteration && getIterationPeriod(this.iteration);
        },
        iterationTitle () {
            return this.iteration?.title || this.iterationPeriod;
        }
    }
};
